var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-calendar-date",
      class: _vm.classObject,
      attrs: { "data-test": "calendar-date" },
      on: { click: _vm.changeNg },
    },
    [
      _c("span", { staticClass: "boss-calendar-date-text" }, [
        _vm._v(_vm._s(_vm.displayText)),
      ]),
      _vm._v(" "),
      _vm.isCandidate
        ? _c("div", {
            staticClass: "boss-calendar-date-candidate",
            attrs: { "data-test": "candidate" },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }